import React, { Component } from 'react'
import './Style.scss'
import LinkOnly from './LinkOnly';
import ReactPlayerLoader from '@brightcove/react-player-loader';

export class TextOnly extends Component {


    render() {
        var content = this.props.articleObj;
        return (

            <div className={`${content.attributes.articleRendering} ${content.attributes.class}`} data-type="TextOnly"
                style={content.attributes.articlePadding ? { padding: `${content.attributes.articlePadding}` } : {}}>
                {content.attributes && content.attributes.mainSectionUrl ?
                    <a href={content.attributes.mainSectionUrl}>
                        <div className='card-design'>
                            {content.title && content.title != "" ?
                                <p className={`card-text ${content.attributes && content.attributes.titleCss}`} dangerouslySetInnerHTML={{ __html: content.title }}></p>
                                : ""}
                            {content.body ?
                                <div className='card-body cms-green-btn' dangerouslySetInnerHTML={{ __html: content.body }}></div>
                                : ""}
                        </div>
                    </a> :
                    <div className='card-design'>
                        {content.title && content.title != "" ?
                            <p className={`card-text ${content.attributes && content.attributes.titleCss}`} dangerouslySetInnerHTML={{ __html: content.title }}></p>
                            : ""}
                        {content.body && content.attributes?.textMainSectionUrl ?
                            <a target={content?.attributes?.openLinkInNewTabYn === "true" ? "_blank" : ""}
                            href={content.attributes.textMainSectionUrl} className='card-body cms-green-btn article-html-content'  dangerouslySetInnerHTML={{ __html: content.body }}></a>
                            : content.body ? <div className='card-body cms-green-btn article-html-content' dangerouslySetInnerHTML={{ __html: content.body }}></div> :
                            ""}
                    </div>}

                {content.attributes.videoId ?
                    content.attributes.videoType && content.attributes.videoType == "vimeo" ?
                        <iframe src={`https://player.vimeo.com/video/${content.attributes.videoId}`} />
                        :
                        content.attributes.videoType == "brightcove" ?
                            <ReactPlayerLoader
                                id="playlist-player-id"
                                playerId={content.playerId ? content.playerId : ""}
                                accountId={content.accountId ? content.accountId : ""}
                                videoId={content.attributes.videoId}
                                options={{
                                    responsive: true,
                                    autoplay: false,
                                    muted: true
                                }}
                            />
                            : "" : ""}
                {content.attributes.linkName ? <LinkOnly articleObj={content} /> : ""}
            </div>

        )
    }
}

export default TextOnly
